import { MRT_ColumnFiltersState } from "material-react-table";

type FilterViewKey = string;

export type OneViewFilter = {
    filterName: string;
    columnFilters: MRT_ColumnFiltersState;
    columnOrder?: string[];
    columnVisibility?: Record<string, boolean>;
};

type StoredViewData = {
    columnFilters: MRT_ColumnFiltersState;
    columnOrder?: string[];
    columnVisibility?: Record<string, boolean>;
};

export type InnerViewFilter = Record<FilterViewKey, string>;

const parseStoredViewData = (raw: string): StoredViewData => {
    const parsed = JSON.parse(raw);
    // Old format: value was JSON.stringify(MRT_ColumnFiltersState) — an array
    if (Array.isArray(parsed)) {
        return { columnFilters: parsed as MRT_ColumnFiltersState };
    }
    // New format: value is JSON.stringify({ columnFilters, columnOrder?, columnVisibility? })
    return parsed as StoredViewData;
};

export const stringToView = (value: string, customOrder?: string[]): OneViewFilter[] => {
    const previousAsObj = JSON.parse(value) as InnerViewFilter;
    const allFilters = Object.entries(previousAsObj).map(([filterViewKey, storedDataAsString]) => {
        const { columnFilters, columnOrder, columnVisibility } = parseStoredViewData(storedDataAsString);
        const oneViewFilter: OneViewFilter = {
            filterName: filterViewKey,
            columnFilters,
            columnOrder,
            columnVisibility,
        };
        return oneViewFilter;
    });

    if (customOrder && customOrder.length > 0) {
        const orderIndex = new Map(customOrder.map((name, i) => [name, i]));
        return allFilters.toSorted((a, b) => {
            const ia = orderIndex.get(a.filterName) ?? Number.MAX_SAFE_INTEGER;
            const ib = orderIndex.get(b.filterName) ?? Number.MAX_SAFE_INTEGER;
            if (ia !== ib) return ia - ib;
            return a.filterName.localeCompare(b.filterName);
        });
    }

    return allFilters.toSorted((a, b) => a.filterName.localeCompare(b.filterName));
};
